import { render, staticRenderFns } from "./VerticalButtonGroup.vue?vue&type=template&id=6191a014&lang=html&"
import script from "./VerticalButtonGroup.vue?vue&type=script&lang=js&"
export * from "./VerticalButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports